import React, { ReactNode, useEffect, useRef } from 'react';

interface TriStateCheckboxProps {
    checked: boolean;
    indeterminate?: boolean;
    onChange: () => void;
    children: ReactNode;
    className?: string;
    labelClassName?: string;
}

const TriStateCheckbox: React.FC<TriStateCheckboxProps> = ({
    checked,
    indeterminate = false,
    onChange,
    children,
    className = 'talent-toggle',
    labelClassName = 'talent-name',
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate && !checked;
        }
    }, [checked, indeterminate]);

    return (
        <label className={className}>
            <input ref={inputRef} type="checkbox" checked={checked} onChange={onChange} />
            <span className={labelClassName}>{children}</span>
        </label>
    );
};

export default TriStateCheckbox;
